export enum UTMSource {
  POLLS = "polls",
  WELLNESS_DETAILS = "wellness_details",
  WELLNESS_CARD = "wellness_card"
}
export enum UTMMedium {
  SHARE_LINK = "share_link"
}

export function addUTMToLink(url: string, source: UTMSource, medium: UTMMedium) {
  const link = new URL(url)
  link.searchParams.set("utm_source", source)
  link.searchParams.set("utm_medium", medium)
  return link.toString()
}
